import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from '../../../mixin/mixin.js'

export default {
  mixins: [mixx],
  name: 'cuponesLiqDet',
  data() {
    return {
      msg: '-',
      loading: false,
      loading_f: false,
      tbv: null,
      tbv2: null,
      ventas: [],

      comercios_f: [],

      f_c: {
        desde: this.date_rest(this.currentdate(), -14),
        hasta: this.currentdate(),
      }
    }
  },
  computed: {
    reporte: function () {
      return '/reportes/naranja/liquidacion?dsis=' + window.sssdi + '&desde=' + this.f_c.desde + '&hasta=' + this.f_c.hasta
    }
  },
  mounted: function () {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true
    });
    $('.box').boxWidget();
  },
  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post('/reportes/naranja/liquidacion', this.f_c)
        .then(response => {
          if (response.data.status == 1) {
            for (let i = 0; i < response.data.data.length; i++) {
              for (let d = 5; d < 40; d++) {
                if (![9, 11].includes(d)) {
                  response.data.data[i][d] = this.num_to_many(response.data.data[i][d]);
                }
              }
              this.tbv.row.add(response.data.data[i]);
            }
          }
          this.tbv.draw();
          this.loading = false;
        });

    },
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/liquidacionNJ/index.js